export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes'
export const TIMEOUT_SEC = 10
export const RES_PER_PAGE = 10;
export const KEY = '4e684428-859a-49f4-88a4-27c451317e15'